import request from '@/utils/request';

export function getList(params={}) {
  return request({
    methods:'GET',
    url:'/sysPortal/list',
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js